<template>
  <v-popover
    trigger="hover"
    popover-inner-class="ks-warning-popover__inner"
    popover-base-class="ks-warning-popover"
    :placement="placement"
    :delay="{ show: showDelay, hide: hideDelay }"
    offset="5"
  >
    <slot />

    <template slot="popover">
      <div class="ks-warning">
        <div class="warning" v-for="warning in warnings" :key="warning.title">
          <div v-if="warning.iconName" class="warning-icon">
            <svgicon
              :class="`ks-icon-color-${warning.iconColor}`"
              :icon="warning.iconName"
            />
          </div>
          <div v-if="warning.title" class="warning-title">
            {{ warning.title }}
          </div>
          <div v-if="warning.description" class="warning-description tw:text-sm">
            {{ warning.description }}
          </div>
        </div>
      </div>
    </template>
  </v-popover>
</template>

<script>
  export default {
    props: {
      hideDelay: {
        type: Number,
        default: 0,
      },
      placement: {
        type: String,
        default: 'top',
      },
      showDelay: {
        type: Number,
        default: 250,
      },
      warnings: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style lang="scss" scoped>
  @use "~Styles/variables";
  @use "~Styles/colors";

  .help-icon {
    margin-left: 5px;
    fill: inherit;
    opacity: .75;

    &:hover {
      opacity: 1;
    }
  }

  .ks-warning {
    background-color: colors.$kommander-white;
    padding: 8px 15px 8px 8px;
    box-shadow: variables.$kommander-shadow-z-2;
    max-width: 350px;
    display: grid;
    grid-gap: 15px;
  }

  .warning {
    display: grid;
    grid-template-columns: max-content auto;
    grid-gap: 0 5px;
    grid-template-rows: repeat(2, max-content);
    grid-template-areas:
      'icon title'
      'empty description';

    &-icon {
      display: flex;
      grid-area: icon;

      svg {
        background-size: 28px;
        height: 28px;
        width: 28px;
      }
    }

    &-title {
      align-self: center;
      grid-area: title;
      font-weight: bold;
    }

    &-description {
      grid-area: description;
    }
  }
</style>

<style lang="scss">
  @use "~Styles/variables";
  .ks-warning-popover {
    z-index: variables.$popover-z;
  }
</style>
